// 设置token
export const SET_TOKEN = " SET_TOKEN";
export type SET_TOKEN_TYPE = typeof SET_TOKEN;

// 设置用户信息
export const SET_MEMBER = "SET_MEMBER";
export type SET_MEMBER_TYPE = typeof SET_MEMBER;
